<template>
    <div class="analysis">
        <hk-header></hk-header>
        <div v-if="questionList.length !== 0" class="analysis-container">
            <div class="analysis-container-top">
                <h2 class="test-title">{{ questionMsg.paperName }}</h2>
                <p class="teacher-subject">
                    授课老师：{{ questionMsg.teacherName }} / 科目：【
                    {{ questionMsg.subjectName }} 】
                </p>
                <div class="attention">
                    <h4>注意事项</h4>
                    <p>请于规定时间内作答，时间结束后立即收卷</p>
                </div>
            </div>
            <div class="analysis-container-content">
                <ul class="subject">
                    <li
                        v-for="(item, index) in questionList"
                        :key="index"
                        :class="[
                            { single: item.type === 1, multiple: item.type === 2 },
                            'subject-item'
                        ]"
                    >
                        <p v-mathjax="item.title" class="subject-item-stem">
                            {{
                                `${index + 1}、【${
                                    item.type === 1
                                        ? '单选题'
                                        : item.type === 2
                                        ? '多选题'
                                        : '问答题'
                                }】 ${item.title}`
                            }}
                            <span></span>
                        </p>
                        <p v-if="item.images" class="subject-item-img">
                            <img :src="item.images" alt="" />
                        </p>
                        <div v-for="(option, k) in item.options" :key="k" class="option">
                            <div class="option-text">
                                <span
                                    :class="{
                                        right: rightChoose(option.optionId, item.rightAnswer),
                                        error: errorChoose(
                                            option.optionId,
                                            item.answer,
                                            item.rightAnswer
                                        )
                                    }"
                                ></span>
                                {{ defaultOption[k] + '、' }}
                                <p v-mathjax="option.optionContent">{{ option.optionContent }}</p>
                            </div>
                            <div v-if="item.option1_img" class="option-img">
                                <img :src="item.option1_img" alt="" />
                            </div>
                        </div>
                        <el-collapse v-model="activeNames">
                            <el-collapse-item :name="index">
                                <template #title>
                                    <div class="title">
                                        <b class="right-answer"
                                            >正确答案：{{
                                                rightAnswerToEN(item.rightAnswer, item.options)
                                            }}</b
                                        >
                                        <span class="show-analysis">展开解析</span>
                                    </div>
                                </template>
                                <div v-html="item.analysis">{{ item.analysis }}</div>
                            </el-collapse-item>
                        </el-collapse>
                    </li>
                </ul>
            </div>
        </div>
        <hk-footer></hk-footer>
    </div>
</template>

<script>
import HkHeader from '@components/HkHeader';
import HkFooter from '@components/HkFooter';
import { getAnalysis } from '@api/test';
export default {
    components: {
        HkHeader,
        HkFooter
    },
    data() {
        return {
            questionMsg: {
                title: '有理数的加减法 - 随堂测试',
                teacher: '乐意',
                subject: '数学'
            },
            questionList: [],
            defaultOption: ['A', 'B', 'C', 'D', 'E'],
            activeNames: ''
        };
    },
    computed: {
        scheduleId() {
            return this.$route.query.scheduleId;
        }
    },
    created() {
        this.analysis();
    },
    mounted() {},
    methods: {
        rightAnswerToEN(arr, options) {
            let optionEN = [];
            const { defaultOption } = this;
            const rightAnswerArr = JSON.parse(arr);
            options.forEach((option, index) => {
                rightAnswerArr.forEach((item) => {
                    if (option.optionId === item) {
                        optionEN.push(defaultOption.filter((item, key) => key === index)[0]);
                    }
                });
            });
            return optionEN.join('、');
        },
        // showAnalysis(item, index) {
        //     item.showAnalysis = !item.showAnalysis;
        //     if (item.showAnalysis) {
        //         // console.log(this.$refs[`contentHeight${index}`][0])
        //         this.$refs[`contentHeight${index}`][0].style.display = 'block';
        //     }
        // },
        rightChoose(id, arr) {
            if (!arr) {
                return false;
            }
            const rightAnswerArr = JSON.parse(arr);
            return rightAnswerArr.some((item) => item === id);
        },
        errorChoose(id, arr1, arr2) {
            if (!arr1 || !arr2) {
                return false;
            }
            const answerArr = JSON.parse(arr1);
            const rightAnswerArr = JSON.parse(arr2);
            const bool =
                answerArr.some((item) => item === id) &&
                !rightAnswerArr.some((item) => item === id);
            return bool;
        },
        analysis() {
            getAnalysis(this.scheduleId).then((res) => {
                this.questionList = res.data.questions;
                this.questionMsg = res.data.paperInfo;
            });
        }
    }
};
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
.analysis {
    width: 100%;
    min-width: 1200px;
    background-color: #f8fafc;
    padding-bottom: 30px;
    padding-top: 83px;
    min-height: 100vh;
    &-container {
        box-sizing: border-box;
        width: 816px;
        padding: 70px 65px;
        margin: 0 auto 50px;
        background-color: #fff;
        box-shadow: 0px 5px 7px 0px #eaedf7;
        border-radius: 14px;
        &-top {
            .test-title {
                font-size: 24px;
                font-family: PingFang SC;
                font-weight: bold;
                color: #333333;
                line-height: 39px;
                text-align: center;
            }
            .teacher-subject {
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 30px;
                text-align: center;
            }
            .attention {
                display: flex;
                align-items: center;
                width: 100%;
                height: 34px;
                background: #fffdf1;
                border: 1px solid #e4d5bf;
                margin-top: 16px;
                h4 {
                    width: 95px;
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 800;
                    color: #333333;
                    border-right: 1px solid #e4d5bf;
                }
                p {
                    padding-left: 10px;
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #666666;
                }
            }
        }
        &-content {
            margin-top: 25px;
            .subject-item-stem {
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 36px;
                margin-bottom: 20px;
            }
            .subject-item-img {
                padding: 0 0 30px 35px;
            }
            .option {
                box-sizing: border-box;
                padding-left: 35px;
                &-text {
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;
                    span {
                        box-sizing: border-box;
                        width: 20px;
                        height: 20px;
                        background: #f8fafc;
                        border: 1px solid #b2b2b9;
                        border-radius: 10px;
                        margin-right: 12px;
                    }
                    p {
                        color: #333;
                        font-size: 16px;
                    }
                    .right {
                        border: none;
                        background: url('~@images/base/right-icon.png') no-repeat center #2fb270;
                    }
                    .error {
                        border: none;
                        background: url('~@images/base/error-icon.png') no-repeat center #f5461e;
                    }
                }
                &-img {
                    margin-bottom: 25px;
                }
            }
            .multiple {
                .option-text {
                    span {
                        box-sizing: border-box;
                        width: 18px;
                        height: 18px;
                        border-radius: 4px;
                    }
                }
            }
            &::v-deep {
                .el-collapse {
                    box-sizing: border-box;
                    width: 100%;
                    padding-left: 35px;
                    border: none;
                    margin-bottom: 40px;
                }
                .el-collapse-item {
                    box-sizing: border-box;
                    width: 100%;
                    background: #f8fafc;
                    border: 1px solid #cbced0;
                    padding: 0 20px;
                }
                .el-collapse-item__header {
                    border: none;
                    background-color: transparent;
                }
                .el-collapse-item__wrap {
                    border: none;
                    background-color: transparent;
                }
                .title {
                    width: calc(100% - 18px);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .right-answer {
                        font-size: 14px;
                        font-family: PingFang SC;
                        font-weight: 800;
                        color: #333333;
                    }
                    .show-analysis {
                        font-size: 14px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #8a939c;
                    }
                }
                .el-collapse-item__content {
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #666666;
                    line-height: 24px;
                    text-align: justify;
                }
            }
        }
    }
}
</style>
